<template>
  <div>
    <section class="orderSect">
      <!--S 检索-->      
      <el-form inline :model="formInline">
        <el-form-item :label="expecttitle">
          <el-date-picker 
          v-model="formInline.expectedDelvDate" 
          type="daterange"          
          range-separater="至" 
          start-placeholder="开始日期" 
          end-placeholder="结束日期"
          :picker-options="formInline.orderDateOptions"
          :unlink-panels = "true" clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-if="sppsfw == 1" v-model="formInline.timeSlot" placeholder="请选择" class="formTimeSlot" clearable>
            <el-option label="中午" value="09:00:00"></el-option>
            <el-option label="晚上" value="15:00:00"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单号" class="codeSerIpt">
          <el-input  v-model="formInline.orderno" placeholder="请输入订单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="收货人">
            <el-input  v-model="formInline.Name" placeholder="请输入收货人" clearable></el-input>
          </el-form-item>
        <el-form-item label="手机号">
            <el-input  v-model="formInline.phone" placeholder="请输入手机号码" clearable></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="getPrintListDetail">查询</el-button>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" plain @click="$router.back(-1)">返回</el-button>
        </el-form-item>  
      </el-form>
    <!--E 检索-->

    <!--S 快递列表-->
    <div class="allOrderTab individualiz">
      <el-form :model="formInline" inline size="medium">
        <el-form-item class="borderline">
          <em class="greyColor">发货状态</em>
          <el-checkbox-group v-model="formInline.deyStatus" @change="changeStatus">
            <el-checkbox v-for="(item,index) of DeliveryStatusLists" :label="item.value" :key="index">{{item.label}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item class="borderline borderNone">
          <em class="greyColor">打印状态</em>
          <el-checkbox-group v-model="formInline.printStatus">
            <el-checkbox v-for="(item,index) in PrintStatusLists" 
              :label="item.value" :key="index" 
              v-on:change="sourceChange($event,item)">{{item.label}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>     
        <!-- <el-form-item >
            <el-button>导出</el-button>
        </el-form-item>                         -->
      </el-form>
      <el-table v-loading="loading" :data="allExpressData" ref="expressTable" class="orderTable comTable" border :maxHeight="tableHeight">       
        <el-table-column type="index" label="序号" fixed></el-table-column>
        <el-table-column label="快递内容" prop="expcontent" fixed sortable min-width="350">
          <template slot-scope="scope">
            <small>订单号：{{scope.row.orderno}}</small>
            <p class="textFl" :title="scope.row.expcontent">{{scope.row.expcontent}}</p>
            <small>{{expecttitle}}：{{dateTime(scope.row.recvdate, 2)}}</small>
          </template>
        </el-table-column>
        <el-table-column label="收货信息" prop="phone" ortable min-width="350">
          <template slot-scope="scope">
            <div class="shouMsg">
              <em v-if="scope.row.receivername">{{scope.row.receivername}}</em>
              <em v-if="scope.row.receivertel">{{scope.row.receivertel}}</em>
            </div>              
            <p v-if="scope.row.fulladdr" class="greyColor textFl" :title="scope.row.fulladdr">{{scope.row.fulladdr}}</p>
          </template>
        </el-table-column>
        <el-table-column label="快递方式" min-width="250">
          <template slot-scope="scope">
            <p v-if="scope.row.exptype">{{exptypes[scope.row.exptype]}}「{{scope.row.handletype | handleTypeFilter}}」</p>
            <p v-else>{{scope.row.handletype | handleTypeFilter}}</p>
          </template>
        </el-table-column>
        <el-table-column label="发货状态" prop="deliverstate" sortable >
          <template slot-scope="scope">
            <span :class="[{'blueColor':scope.row.deliverstate==1 || scope.row.deliverstate==3},{'orangeColor':scope.row.deliverstate==0},{'redColor':scope.row.deliverstate==2 || scope.row.deliverstate==6},{'greyColor':scope.row.deliverstate==4},{'greenColor':scope.row.deliverstate==5}]">{{scope.row.deliverstate | deliverStateFilter}}</span>
          </template>
        </el-table-column>
        <el-table-column label="打印状态" prop="bprint" sortable >
          <template slot-scope="scope">
            <span :class="[{'orangeColor':scope.row.bprint==0},{'blueColor':scope.row.bprint==1}]" v-if="scope.row.bprint == 0">待打印</span>
            <span :class="[{'orangeColor':scope.row.bprint==0},{'blueColor':scope.row.bprint==1}]" v-if="scope.row.bprint == 1">已打印</span>
          </template>
        </el-table-column>
        <el-table-column label="筛单状态" prop="screenstate" sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.handletype != 1000" :class="scope.row.screenstate | screenStateColorFilter">{{scope.row.screenstate | screenStateFilter}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="100">
          <template slot-scope="scope">
            <span class="blueColor" @click="viewDetail(scope.row.expcode)">详情</span>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="noData"><span>暂无数据</span></div>
        </template>
      </el-table>
    </div>
    <!--E 快递列表-->
    <Page :pageTotal="pagebean.totalnum" :currentPage="pagebean.currentpage" @nowPageParam="setPageparam"></Page>
    </section>

    <!--S 快递详情组件-->
    <DeliveryDetail :deliveryDetailBox="expressDetailShow" :expcode="expcode" @closeDDBox="expressDetailShow = false"></DeliveryDetail>
    <!--E 快递详情组件-->

  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import api from '../../apis/api';
export default {
  name: "PrintListDetail",
  data() {
    return {     
      PrintStatusLists: [
        { label: "待打印", value: "0" },
        { label: "已打印", value: "1" }
      ], //打印状态
      DeliveryStatusLists: [ 
        { label: "待发货", value: "0" },
        { label: "已发货", value: "1" },
        { label: "已补发", value: "2" },
        { label: "退货", value: "3" },
        { label: "无效快递", value: "4" },
        { label: "已签收", value: "5" },
        { label: "异常签收", value: "6" },
      ], //发货状态
      PowerLists:[
        { label: "总部", value: "0" },
        { label: "门店/网点/分销商", value: "1" },
      ],//权限归属
      //检索
      formInline: {
        Name: "", //收货人
        orderno: "", //订单号
        expressno: "", //快递单号
        phone: "", //手机号
        expectedDelvDate: "", //期望发货日期
        timeSlot: "", //中午、晚上时间段选择
        deyStatus:[], //发货状态
        printStatus:[],//打印状态
        ReissueExpress:"",//补发快递
        orderDateOptions: {
          shortcuts: [
            {
              text: "今天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime());
                picker.$emit("pick", [start, end]);
              }
            },{
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近三个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              }
            }
          ]
        }
      },
      allExpressData: [
      ], //全部快递数据
      tableHeight: window.innerHeight * 0.8, //表格动态高度
      expressDetailShow:false, //快递详情
      expgenbatchno: '',//批次编号
      expcode: '',//快递编号
      pagebean: {
        pagesize: 30,
        currentpage: 1
      },//分页
      loading: true,//加载
      exptypes: {},//快递方式集合
      expecttitle: '',//期望发货日期标题
      sppsfw: 0,//是否开通同城配送
    };
  },
  components: {
    Page: resolve => require(["@/components/common/Page.vue"], resolve),
    DeliveryDetail: resolve => require(["@/components/common/DeliveryDetail.vue"], resolve), //快递详情组件
  },
  watch: {

  },
  methods: {
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.expressTable.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 130;
      //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
    },

    //查看详情
    viewDetail(expcode) {
      this.expressDetailShow = true
      this.expcode = expcode
    },

    changeStatus() {
      this.getPrintListDetail()
    },

    sourceChange: function(value, target) {
      this.formInline.printStatus = value ? [target.value] : []
      this.getPrintListDetail()
    },

    //设置分页数据
    setPageparam(nowPageSize, nowCurrentPage) {
      if(nowPageSize) {
        this.pagebean.pagesize = nowPageSize
      }
      if(nowCurrentPage) {
        this.pagebean.currentpage = nowCurrentPage
      }
      this.getPrintListDetail()
    },

    //获取所有的可用快递方式
    getAllExpTypes() {
      if(localStorage.getItem("exptypes")){
        this.exptypes = JSON.parse(localStorage.getItem("exptypes"))
      } else {
        api.GET_ALLEXPMODENAMECACHE({}).then(res => {
          if(res.data.status == '200') {
            this.exptypes = res.data.data.expmodeMap
            localStorage.setItem("exptypes",JSON.stringify(this.exptypes))
          }
        })
      }
    },

    //获取打印批次详情
    getPrintListDetail() {
      this.loading = true
      let params = {
        expgenbatchno: this.expgenbatchno,
        stardate: this.formInline.expectedDelvDate && this.formInline.expectedDelvDate[0] ? this.dateTime(this.formInline.expectedDelvDate[0]) : '',
        enddate: this.formInline.expectedDelvDate && this.formInline.expectedDelvDate[1] ? this.dateTime(this.formInline.expectedDelvDate[1]) : '',
        dateAmPm: this.formInline.timeSlot,
        orderno: this.formInline.orderno, //订单号
        name: this.formInline.Name,
        mobileNumber: this.formInline.phone,
        deliverstate: this.formInline.deyStatus,
        bprint: this.formInline.printStatus,
        pageparam: this.pagebean
      }
      api.FINDEXPGENBATCHDETAIL(params).then(res => {
        if(res.data.status == '200') {
          this.allExpressData = res.data.data
          this.pagebean = res.data.pagebean
        } else {
          this.allExpressData = []
        }
        this.loading = false
      })
    },

  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    //在dom渲染之后
    if (this.$route.params) {
      this.expgenbatchno = this.$route.params.expgenbatchno;
    }
    setTimeout(() => {
      this.getHeight()
      this.getPrintListDetail()
      this.getAllExpTypes()
      this.expecttitle = localStorage.getItem("pubordprintinfo") ? JSON.parse(localStorage.getItem("pubordprintinfo")).expecttitle : ''
    }, 200);
    this.sppsfw = Number(this.ElementControls('sppsfw'))
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight); //销毁监听浏览器视窗变化
  }
};
</script>

<style scoped>
@import "Css/Style.css";

</style>





// WEBPACK FOOTER //
// src/views/DeliveryFolder/PrintListDetail.vue